export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/14ed8dc335eec8ccd043173219a4387f.svg";